import { SCALE } from "@/domains/tokens/static-tokens"

import type { LockApiData, LockStoreDAO } from "./types"

/**
 * Convert API response to Lock Store DAO format
 * Maps NftV4ResponseItem to LockStoreDAO structure
 * Preserves lockAmountRaw from RPC for exact precision
 * Computes lockAmount from lockAmountRaw using token.formatUnits
 */
export function convertApiResponseToLockStoreDAO(apiResponse: LockApiData): LockStoreDAO {
  // If lockAmountRaw is present (from RPC), use it and compute lockAmount from it
  // Otherwise, compute lockAmountRaw from string (loses precision, but backward compatible)
  let lockAmountRaw: bigint
  let lockAmount: number

  if (apiResponse.lockAmountRaw !== undefined) {
    // RPC data: use raw BigInt and compute display amount
    lockAmountRaw = apiResponse.lockAmountRaw
    lockAmount = Number(SCALE.formatUnits(lockAmountRaw))
  } else {
    // Legacy API data: parse from string (loses precision)
    lockAmountRaw = SCALE.parseUnits(apiResponse.lockAmount)
    lockAmount = parseFloat(apiResponse.lockAmount)
  }

  return {
    id: apiResponse.id,
    lockAmount,
    lockAmountRaw,
    lockEnds: apiResponse.lockEnds,
    lockValue: parseFloat(apiResponse.lockValue),
    hasExpired: apiResponse.hasExpired,
    isMaxLocked: apiResponse.isMaxLocked,
    isReset: apiResponse.isReset,
    hasVotes: apiResponse.hasVotes,
    hasVotedThisEpoch: apiResponse.hasVotedThisEpoch,
    lastVoted: apiResponse.lastVoted,
    needsResetToWithdraw: apiResponse.needsResetToWithdraw,
    canWithdraw: apiResponse.canWithdraw,
  }
}
